<template>
  <div class="h-100">
  <transition  enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
        <div class="voting_container h-100" v-if="currentpoll && currentpoll.created_at">
          <h2 class="title" :class="{ 'title-small' : currentpoll.name.length>25 }">{{currentpoll.name}}</h2>
          <ul class="voting d-flex  justify-content-around">
            <li v-for="(option, key, index) in currentpoll.results" :key="index">
                <div class="name" :class="{ 'optionname-small' : option.name.length>35 }">{{option.name}}</div> 
                <div class="result">
                  <span>
                    {{getvotespercent(option.votes)}}%
                  </span>
                </div>
            </li>
          </ul>
          <div class="bottom clearfix">
            <!-- <div class="timeleft mx-2">
              <span v-if="timeover || !timetovote || currentpoll.timetovote==0 ">
                Voting time over.
              </span>
              <span v-else>
                  <countdown :time="timetovote" ref="countdown" :auto-start="true">
                    <template slot-scope="props">{{ props.minutes }}:{{ props.seconds }} remaining</template>
                  </countdown>
              </span>
            </div> -->
            <div class="totalvotes float-right mx-2">
              {{totalvotes}} votes
            </div>
          </div>
        </div>
</transition>
    <!-- <div v-else>
      no vote
    </div> -->    

  </div>
</template>

<script>
import { EventBus } from '@/event-bus';
export default {
  props: ['currentpoll'],
  created() {

  },
  data () {
    return {

    }
  },
  computed: {
    totalvotes(){
      var self = this
      var totalvotes = 0
      if(self.currentpoll){
        _.forEach(self.currentpoll.results, function(value) {
            totalvotes += value.votes;
        });
        return totalvotes
      }
    },
    timeover(){
      if(!this.currentpoll) return
      if(this.currentpoll.created_at+(this.currentpoll.timetovote*1000)<=Date.now()){
        //time over
        return true
      }else{
        return false
        //remainig time
      }
    },
    timetovote(){
      if(!this.currentpoll) return
      return this.currentpoll.created_at+(this.currentpoll.timetovote*1000)-Date.now()
    }

  },
  methods: {
    getvotespercent(number){
      if(number === 0){
        return 0
      }
      return (number/this.totalvotes*100).toFixed(2);
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
    background-color: transparent !important;
}

.voting_container {
  margin: 0 auto;
  display: table;
    background-color: rgba(31, 34, 39, 0.80);
    padding: 10px 15px;
    min-width: 1000px;
    color: white;
    position: relative;
    transition: 1s;
    text-align: center;
}

.voting_container .title {
    color: white;
    margin-bottom: 15px;
    font-size: 30px;
}

.voting_container .title-small {
    font-size: 22px;
}

.voting_container ul.voting {
    list-style: none;
    color: white;
    padding: 0px;
    margin-bottom: 12px;
    overflow: hidden;
}
.voting_container ul.voting li{
  margin: 0 10px;
width: 100%;
  background: rgba(62, 62, 62, 0.85);
  position: relative;
  min-height: 70px;
}


.progressbar{
    height: 30px;
    background: rgba(32, 34, 35, 0.45);
    border: solid 1px #454f54;
}

.progressbar .progressbar_inner {
    height: 100%;
    width: 100%;
    background: #f32f2f;
    transition: 0.3s;
    opacity: 0.9;
}

.votebutton {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    transition: 0.2s;
    
}

.votebutton:hover {
    filter: brightness(75%);
}
.voting_container ul.voting li:nth-child(2) .progressbar .progressbar_inner, .voting_container ul.voting li:nth-child(1) .votebutton {
    background: #f32f2f;
}
.voting_container ul.voting li:nth-child(2) .progressbar .progressbar_inner, .voting_container ul.voting li:nth-child(2) .votebutton {
    background: #47CF47;
}

.voting_container ul.voting li:nth-child(3) .progressbar .progressbar_inner, .voting_container ul.voting li:nth-child(3) .votebutton {
    background: #1C9292;
}
.voting_container ul.voting li:nth-child(4) .progressbar .progressbar_inner, .voting_container ul.voting li:nth-child(4) .votebutton {
    background: #F3882F;
}
.voting_container ul.voting li:nth-child(5) .progressbar .progressbar_inner, .voting_container ul.voting li:nth-child(5) .votebutton {
    background: #644BB4;
}
.option_top {
    overflow: hidden;
    color: #e8ecf1;
}
.voting .name {
    font-size: 20px;
    margin-bottom: 45px;
    color: #c5def1;
}
.optionname-small {
  font-size: 18px !important;
}
.voting .result {
    font-size: 34px;
    position: absolute;
    bottom: 0;
    text-align: center;
    width: 100%;
    
}

.hidebutton{
    position: absolute;
    right: 15px;
    top: 7px;
  }

  .hidebutton a {
      color: white;
  }
  .hidebutton a:hover {
      color: #ff9898;
      cursor: default;
  }

  .showbutton {
    background: rgba(31, 34, 39, 0.55);
    color: white;
    text-align: center;
    transition: 0.3s;
    
    cursor: default;
    border-radius: 6px;
    font-size: 20px;
    padding: 5px;
  }

  .showbutton:hover {
    background: rgba(31, 34, 39, 0.85);
    cursor: default;
  }

  .bottom {
    color: #c2cbd4;
    overflow: hidden;
    font-size: 16px;
    margin-top: -5px;
  }

.bottom .timeleft {
/* float: left; */
}

.bottom .totalvotes {
/* float: left; */
}
</style>



// WEBPACK FOOTER //
// src/components/themes/Horizontal.vue